import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M31.3313 8.69226C30.9633 7.33731 29.879 6.27019 28.5022 5.90805C26.0067 5.25 16 5.25 16 5.25C16 5.25 5.99337 5.25 3.49781 5.90805C2.12103 6.27025 1.0367 7.33731 0.668671 8.69226C0 11.1482 0 16.2722 0 16.2722C0 16.2722 0 21.3963 0.668671 23.8522C1.0367 25.2072 2.12103 26.2298 3.49781 26.5919C5.99337 27.25 16 27.25 16 27.25C16 27.25 26.0066 27.25 28.5022 26.5919C29.879 26.2298 30.9633 25.2072 31.3313 23.8522C32 21.3963 32 16.2722 32 16.2722C32 16.2722 32 11.1482 31.3313 8.69226ZM12.7273 20.9245V11.62L21.0909 16.2723L12.7273 20.9245Z'],
  name: 'brandYoutube',
  oldName: 'fabYoutube'
} as IconDefinition
